import React from "react";
import {Button, Modal, PageHeader, Tabs} from "antd";

import CompanyProfile from "./CompanyProfile";
import PersonalProfile from "./PersonalProfile";
import {
  getCorporateAccountDetails,
  changePassword,
} from "api/api";
import { validatePassword } from "utils/utils";
import { displayGenericError } from "common/notifications";

import "./ManageProfilePage.scss";
import {renewAccessToken, submitOTPChangePassword} from "../../api/api";
import CustomRxPageHeader from "../../rxcomponents/CustomRxPageHeader";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

const { TabPane } = Tabs;

class ManageProfilePage extends React.Component {
  state = {
    isLoading: true,
    corporates: {},
    otpVisible: false,
    successVisible: false,
    password:''
  };
  renewAccessToken =() =>{
    const intl = this.props.useIntl;
    renewAccessToken( localStorage.getItem("ACCESS_TOKEN")).then(response=>{
      localStorage.setItem("ACCESS_TOKEN", response.accessToken);
    }).catch(error=>{
      if(error.status === 401){
        localStorage.removeItem("ACCESS_TOKEN");
        this.props.handleLogout("/","success", intl.formatMessage({id: "app.message.sessiontimeout"}));
      }
    })
  }
  componentDidMount() {
    this.renewAccessToken();
    this.setState({
      isLoading: true
    });
    getCorporateAccountDetails()
      .then(response => this.setState({ corporates: response }))
      .catch(displayGenericError);
  }


  handleChangePassword = value => {
    const intl = this.props.useIntl;
    const { password, passwordVerification } = value;
    if (
      !validatePassword(password) ||
      !validatePassword(passwordVerification)
    ) {
      displayGenericError({
        message:
        intl.formatMessage({id: "app.message.manageprofilepage.passwordlength"})
      });
      return;
    }
    changePassword(value)
      .then(() => {
        this.setState({ otpVisible: true,password: value });
      })
      .catch(displayGenericError);
  };

  handleSubmitOTP = otp => {
    submitOTPChangePassword(otp,this.state.password.currentPassword,  this.state.password.password, "/api/secured/customer/password/otp")
      .then(() => {
        this.setState({
          successVisible: true
        })
      })
      .catch(e => {
        this.setState({ otpVisible: false })
        displayGenericError(e)
      });
  };

  returnToMainClicked () {
    //localStorage.removeItem("ACCESS_TOKEN");
    window.location = "/";
  }

  render() {
    const intl = this.props.useIntl;
    const { customer } = this.props;
    const { corporates } = this.state;
    return (
      <div className="manage-profile">
        {/*<PageHeader className="bp-page-header" title="Manage Profile" />*/}
        <CustomRxPageHeader customer={customer}
            title={intl.formatMessage({id: "app.sidebar.manageprofile"})}
        />
        <div className="bp-page-content bp-page-large">
          <Tabs type="card">

            {(customer != null && customer.corporateAccountDetails != null) && (
            <TabPane tab={intl.formatMessage({id: "app.page.manageprofilepage.companyprofile"})} key="company">
              <CompanyProfile profile={customer} 
                onChangePassword={this.handleChangePassword}
                onSubmitOTP={this.handleSubmitOTP}
                showOTPModal={this.state.otpVisible}
              />
            </TabPane>)}

            {(customer != null && customer.personalAccountDetails != null) && (
            <TabPane tab={intl.formatMessage({id: "app.page.manageprofilepage.personalprofile"})} key="personal">
              <PersonalProfile
                profile={customer}
                onChangePassword={this.handleChangePassword}
                onSubmitOTP={this.handleSubmitOTP}
                showOTPModal={this.state.otpVisible}
              />
            </TabPane>)}
            <Modal
                wrapClassName="otp-sign-in"
                visible={this.state.successVisible}
                closable={false}
                footer={null}
            >
              <div className="opt-layout-wrapper verify-page-modal">
                <div className="inner-content">
                    <h2 className="fw-700">You have successfully changed password</h2><br/>
                    <div className="buttons-section">
                      <Button
                          type="primary"
                          className="btn-wide-md"
                          onClick={this.returnToMainClicked}
                      >
                        OK
                      </Button>
                    </div>
                </div>
              </div>
            </Modal>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default withUseIntl(ManageProfilePage);